package com.cybersoftsolution.cybersoftsolutionweb.components.icons

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.px

@Composable
fun VectorIcon(
    modifier: Modifier = Modifier,
    pathData: String,
    color: CSSColorValue,
    size: Int = 48
){

    Svg(
        attrs = modifier
            .id(IdConst.svgParentIcon)
            .width(size.px)
            .height(size.px)
            .toAttrs{
                attr("viewBox", "0 0 $size $size")
                attr("fill", "none")
            }
    ){
        Path(
            attrs =  modifier

                .id(IdConst.vectorIcon)
                .toAttrs{
                    attr("d", pathData)
                    attr("stroke",color.toString())
                    attr("stroke-width", "4")
                    attr("stroke-linecap", "round")
                    attr("stroke-linejoin", "round")

                }
        )
    }
}